<template>
  <div
    class="flex flex-col mt-8 w-full motion-safe:animate-pulse motion-reduce:animate-none"
  >
    <span v-if="textForScreenReaders" class="sr-only">
      {{ textForScreenReaders }}
    </span>
    <div class="flex flex-row items-center w-full" aria-hidden="true">
      <div class="flex flex-col col-auto">
        <div class="w-32 h-32 rounded-md me-16 bg-text-disabled"></div>
      </div>
      <div class="flex flex-col grow">
        <span class="w-full h-22 mt-2 bg-text-disabled"></span>
        <span class="w-190 h-22 mt-2 bg-text-disabled"></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  textForScreenReaders?: string;
}

defineProps<Props>();
</script>
